import React,{useState,useEffect} from 'react';
import DataTableWarehouseStatusSum from '../../components/datatable/DataTableWarehouseStatusSum';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  WarehouseStatusDatatable = (props) => {

    const [t] = useTranslation();  
    const [warehouseId, setWarehouseId] = useState('');      
    const [url, setUrl] = useState('');   
    const [urlExcel, setUrlExcel] = useState('');   
  //  const [entityId, setEntityId] = useState();
    const tableName = t('warehouse.label.stockStatus'); 


    
    const columns = [       
        { name: "Id",  selector: "id", omit: true},
        { name: t('article.label.articleName'),  sortable: true, selector: "article\.name", minWidth: '500px'},    		
        { name: t('article.label.articleNumber'),  sortable: true, selector: "article\.nbr"},  
     //   { name: t('article.label.articleNumber'), sortable: true, selector: "article.nbr"},    		       
        { name: t('warehouse.label.qty'),  sortable: true,  selector: "qty"},      
     //   { name: t('article.label.measureUnit'), sortable: true,  selector: "article.measureUnit"},   
        { name: t('warehouse.label.priceExcludeVatAvg'), sortable: true,  selector: "unitPriceExcludeVatAvg"},   
        { name: t('warehouse.label.totalExcludeVatAvg'), sortable: true,  selector: "totalPriceExcludeVatAvg"},   
      //  { name: t('general.label.description'), sortable: true,  selector: "article.description"},
      //  { name: t('warehouse.label.warehouseName'), sortable: true,  selector: "warehouse.name"},
      //  { name: t('warehouse.label.warehouseNumber'), sortable: true,  selector: "warehouse.number"}
    ];        


    
    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('general.label.name'), data: "article.name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
        { name: t('article.label.articleNumber'), data: "article.nbr", orderable: true,  searchable: true, search: {value: '',regex: false}},       
        { name: t('warehouse.label.qty'), data: "qty", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('article.label.measureUnit'), data: "article.measureUnit", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('warehouse.label.priceExcludeVatAvg'), data: "unitPriceExcludeVatAvg", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('warehouse.label.totalExcludeVatAvg'), data: "totalPriceExcludeVatAvg", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('general.label.description'), data: "article.description", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('warehouse.label.warehouseName'), data: "warehouse.name", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('warehouse.label.warehouseNumber'), data: "warehouse.number", orderable: true,  searchable: true, search: {value: '',regex: false}}                 
    ];        

  //  const url = RestService.getBaseURL()+"warehouse/getStatusList?warehouseId="+warehouseId;   
   // const urlExcel = RestService.getBaseURL()+"warehouse/getStatusExcelList?warehouseId="+warehouseId;          
    
   
 
    useEffect(() => {
        setWarehouseId(props.warehouseId);
        setUrl(RestService.getBaseURL()+"warehouse/getStatusList?warehouseId="+props.warehouseId);
        setUrlExcel(RestService.getBaseURL()+"warehouse/getStatusExcelList?warehouseId="+props.warehouseId);
      }, [props.warehouseId]);

     const handleCallback  = (id) => {
                     
     };
   
          
    
         return (
           
             <DataTableWarehouseStatusSum
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={true}
                 warehouseId={warehouseId}
             />
           
         );
    
 
  
 };

export default WarehouseStatusDatatable;

